import './shop-pagination.css';
import '../form/form.css';

const ShopPagination = class Pagination extends HTMLElement {
    constructor() {
        super();
        this.page = parseInt(this.getAttribute('page'));
        this.numberOfPages = parseInt(this.getAttribute('number-of-pages'));
        this.render();
    }

    static get observedAttributes () {
        return ['page', 'number-of-pages'];
    }

    attributeChangedCallback (name, oldValue, newValue) {
        switch (name) {
            case 'page':
                this.page = parseInt(newValue);
                break;
            case 'number-of-pages':
                this.numberOfPages = parseInt(newValue);
                break;
        }
        this.innerHTML = '';
        this.render();
    }

    render () {
        this.className = 'pagination';

        const prevButton = document.createElement('button');
        prevButton.className = 'pagination__button pagination__button--prev';
        prevButton.textContent = 'Previous';
        prevButton.disabled = this.page <= 0;
        prevButton.addEventListener('click', () => this.changePage(this.page - 1));
        this.appendChild(prevButton);

        const createPageButton = (pageNumber, isActive = false) => {
            const pageButton = document.createElement('button');
            pageButton.className = `pagination__button pagination__button--page ${isActive ? 'pagination__button--active' : ''}`;
            pageButton.textContent = pageNumber + 1;
            pageButton.addEventListener('click', () => this.changePage(pageNumber));
            this.appendChild(pageButton);
        };

        const createDots = () => {
            const dots = document.createElement('span');
            dots.className = 'pagination__dots';
            dots.textContent = '...';
            this.appendChild(dots);
        };

        if (this.numberOfPages <= 5) {
            for (let i = 0; i < this.numberOfPages; i++) {
                createPageButton(i, i === this.page);
            }
        } else {
            if (this.page > 2) {
                createPageButton(0);
                if (this.page > 3) createDots();
            }

            const start = Math.max(0, this.page - 2);
            const end = Math.min(this.numberOfPages, this.page + 3);

            for (let i = start; i < end; i++) {
                createPageButton(i, i === this.page);
            }

            if (this.page < this.numberOfPages - 3) {
                if (this.page < this.numberOfPages - 4) createDots();
                createPageButton(this.numberOfPages - 1);
            }
        }

        const nextButton = document.createElement('button');
        nextButton.className = 'pagination__button pagination__button--next';
        nextButton.textContent = 'Next';
        nextButton.disabled = this.page >= this.numberOfPages - 1;
        nextButton.addEventListener('click', () => this.changePage(this.page + 1));
        this.appendChild(nextButton);

        const hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.name = 'page';
        hiddenInput.value = this.page;
        this.appendChild(hiddenInput);
    }

    changePage (pageNumber) {
        this.querySelector('input').value = pageNumber;
        this.closest('product-shop').submitForm(pageNumber);
        this.setAttribute('page', pageNumber);
    }

    connectedCallback () { }
};

customElements.define('shop-pagination', ShopPagination);